import React from 'react'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean
}

export function Label({ children, required, className, ...props }: LabelProps) {
  return (
    <label
      className={`text-sm font-medium text-foreground ${required ? 'after:content-["*"] after:text-destructive after:ml-1' : ''} ${className}`}
      {...props}
    >
      {children}
    </label>
  )
}
